import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * GPTMetricsApi
 * Wrapper for aggregated GPT prompt usage metrics endpoints.
 * All functions accept a single filters object. Optional filters omitted from query string.
 * Shared filters:
 *  - from (ISO string | Date)
 *  - to (ISO string | Date)
 *  - interval (hour|day) for *-series endpoints
 *  - userId, documentId, conversationId
 *  - promptTypes: comma separated string OR array of strings
 *  - perUser (boolean) for usage-series when wanting per-user breakdown
 *  - limit for ranking style endpoints
 */
function buildParams(raw) {
  const p = new URLSearchParams();
  if (!raw) return p;
  const {
    from, to, interval, userId, documentId, conversationId,
    promptTypes, perUser, limit, metric
  } = raw;
  if (from) p.set('from', typeof from === 'string' ? from : from.toISOString());
  if (to) p.set('to', typeof to === 'string' ? to : to.toISOString());
  if (interval) p.set('interval', interval);
  if (userId) p.set('userId', userId);
  if (documentId) p.set('documentId', documentId);
  if (conversationId) p.set('conversationId', conversationId);
  if (promptTypes && promptTypes.length) {
    const list = Array.isArray(promptTypes) ? promptTypes.join(',') : promptTypes;
    p.set('promptTypes', list);
  }
  if (perUser != null) p.set('perUser', perUser);
  if (limit != null) p.set('limit', limit);
  if (metric) p.set('metric', metric);
  return p;
}

function doGet(path, filters) {
  const params = buildParams(filters);
  const qs = params.toString();
  return fetchWithAuth(`${DATA_SERVICE_BASE_URL}${path}${qs ? `?${qs}` : ''}`, { method: 'GET' });
}

export const GPTMetricsApi = {
  getUsageSeries: (filters) => doGet('/api/stats/gpt/prompts/metrics/usage-series', filters),
  getPromptTypeSeries: (filters) => doGet('/api/stats/gpt/prompts/metrics/prompt-type-series', filters),
  getTopUsers: (filters) => doGet('/api/stats/gpt/prompts/metrics/top-users', { metric: 'cost', ...filters }),
  getPromptTypeDistribution: (filters) => doGet('/api/stats/gpt/prompts/metrics/prompt-type-distribution', filters),
  getDocumentUsage: (filters) => doGet('/api/stats/gpt/prompts/metrics/document-usage', filters),
  getCorrelationSeries: (filters) => doGet('/api/stats/gpt/prompts/metrics/correlation-series', filters),
  getEfficiencySeries: (filters) => doGet('/api/stats/gpt/prompts/metrics/efficiency-series', filters),
  getSummary: (filters) => doGet('/api/stats/gpt/prompts/metrics/summary', filters),
};

export default GPTMetricsApi;
